var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluentMdl2CompletedSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1436_16645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0C10.3721 0 11.2132 0.111328 12.0234 0.333984C12.8337 0.556641 13.5882 0.878255 14.2871 1.29883C14.986 1.7194 15.6261 2.21419 16.2075 2.7832C16.7889 3.35221 17.2868 3.99235 17.7012 4.70361C18.1156 5.41488 18.4341 6.17253 18.6567 6.97656C18.8794 7.7806 18.9938 8.62175 19 9.5C19 10.3721 18.8887 11.2132 18.666 12.0234C18.4434 12.8337 18.1217 13.5882 17.7012 14.2871C17.2806 14.986 16.7858 15.6261 16.2168 16.2075C15.6478 16.7889 15.0076 17.2868 14.2964 17.7012C13.5851 18.1156 12.8275 18.4341 12.0234 18.6567C11.2194 18.8794 10.3783 18.9938 9.5 19C8.62793 19 7.78678 18.8887 6.97656 18.666C6.16634 18.4434 5.41178 18.1217 4.71289 17.7012C4.014 17.2806 3.37386 16.7858 2.79248 16.2168C2.2111 15.6478 1.71322 15.0076 1.29883 14.2964C0.88444 13.5851 0.565918 12.8275 0.343262 12.0234C0.120605 11.2194 0.0061849 10.3783 0 9.5C0 8.62793 0.111328 7.78678 0.333984 6.97656C0.556641 6.16634 0.878255 5.41178 1.29883 4.71289C1.7194 4.014 2.21419 3.37386 2.7832 2.79248C3.35221 2.2111 3.99235 1.71322 4.70361 1.29883C5.41488 0.88444 6.17253 0.565918 6.97656 0.343262C7.7806 0.120605 8.62175 0.0061849 9.5 0ZM15.0942 6.35498L13.8325 5.09326L7.71875 11.207L5.16748 8.65576L3.90576 9.91748L7.71875 13.7305L15.0942 6.35498Z",
    fill: "#1D2951",
    fillOpacity: 0.65
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1436_16645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentMdl2CompletedSolid);
export default __webpack_public_path__ + "static/media/fluent-mdl2_completed-solid.e93b1b309c5893a7becfc7141d274a6b.svg";
export { ForwardRef as ReactComponent };